import { render, staticRenderFns } from "./TenantDetailsNav.vue?vue&type=template&id=51823789"
import script from "./TenantDetailsNav.vue.ts?vue&type=script&lang=ts&external"
export * from "./TenantDetailsNav.vue.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports